import {
  IntervalApi,
  SubDocumentApi,
} from 'components/devexpress/RichEdit/dx-richedit';

const base64ImgRegex =
  /<img\b[^>]*?\bsrc\s*=\s*(['"])(data:image\/[^'"]+)\1[^>]*?>/gi;

type ExtractedImage = { marker: string; src: string };

/**
 * DevExpress' insertHtml chokes on <img src="data:image/...">.
 * Replace each data-URI image with a unique plain-text marker so insertHtml
 * succeeds; the caller can then locate the markers and replace them with
 * real pictures via SubDocumentApi.insertPicture.
 */
export const extractImages = (
  html: string,
): {
  html: string;
  images: ExtractedImage[];
} => {
  const images: ExtractedImage[] = [];
  let i = 0;
  const htmlWithImageMarkers = html.replace(
    base64ImgRegex,
    (_match, _q, src) => {
      const marker = `\u0001IMG_${i++}_\u0001`;
      images.push({ marker, src });
      return marker;
    },
  );
  return { html: htmlWithImageMarkers, images };
};

/**
 * Searches through the field interval, finds each marker left by extractDataUriImages,
 * and replaces it with an inserted picture.
 */
export const reinsertExtractedImages = (
  doc: SubDocumentApi,
  fieldInterval: IntervalApi,
  images: ExtractedImage[],
) => {
  for (const image of images) {
    const text = doc.getText(fieldInterval);
    const markerIndex = text.indexOf(image.marker);
    if (markerIndex < 0) continue;

    const imageIntervalStart = (fieldInterval.start as number) + markerIndex;
    try {
      doc.insertPicture(imageIntervalStart, image.src);
      doc.deleteText({
        start: imageIntervalStart + 1,
        length: image.marker.length,
      } as any);
    } catch (e) {
      console.error('reinsertExtractedImages: insertPicture failed', e);
      doc.deleteText({
        start: imageIntervalStart,
        length: image.marker.length,
      } as any);
    }
  }
};
